import { useTranslate } from "ra-core";

import { Badge } from "@/components/ui/badge";

import type { Priority } from "../types";

const VARIANTS: Record<
  Priority,
  "outline" | "secondary" | "default" | "destructive"
> = {
  low: "outline",
  medium: "secondary",
  high: "default",
  urgent: "destructive",
};

export const PriorityBadge = ({
  priority,
  className,
}: {
  priority: Priority;
  className?: string;
}) => {
  const translate = useTranslate();
  return (
    <Badge variant={VARIANTS[priority]} className={className}>
      {translate(`crm.operations.priorities.${priority}`)}
    </Badge>
  );
};
